import { Routes } from '@angular/router';
import { OktaAuthGuard, OktaCallbackComponent } from '@okta/okta-angular';
export const APP_TITLE = 'Offline Process Plan';
export const routes: Routes = [
    // {
    //     path: 'login',
    //     loadComponent: () => import('./components/login-window/login-window.component'),
    //     title: `${title} | Logowanie`,
    // },

        {
        path: 'dashboard-new',
        loadComponent: () => import('./components/pages/dashboard/dashboard.component'),
        title: `${APP_TITLE} | Dashboard`,
        canActivate: [OktaAuthGuard],
    },
    {
        path: 'wiring',
        loadComponent: () => import('./components/pages/wiring/wiring.component'),
        title: `${APP_TITLE} | Wiring`,
        canActivate: [OktaAuthGuard],
    },

    {
        path: 'config',
        loadComponent: () => import('./components/pages/configuration/configuration.component'),
        title: `${APP_TITLE} | Wiring`,
        canActivate: [OktaAuthGuard],
    },

    {
        path: 'help',
        loadComponent: () => import('./app-core/ui/sidenav/help/help.component'),
        title: `${APP_TITLE} | Pomoc`,
        canActivate: [OktaAuthGuard],
    },
    {
        path: 'help/:item',
        loadComponent: () => import('./app-core/ui/sidenav/help/help.component'),
        title: `${APP_TITLE} | Pomoc`,
        canActivate: [OktaAuthGuard],
    },
    // {
    //     path: 'notification',
    //     loadComponent: () => import('./app-core/ui/sidenav/notification/notification.component'),
    //     title: `${title} | Notifications`,
    //     //canActivate: [AuthGuard],
    // },
    {
        path: 'preferences',
        loadComponent: () => import('./app-core/ui/sidenav/account/account.component'),
        title: `${APP_TITLE} | Preferencje`,
        canActivate: [OktaAuthGuard],
    },
    // {
    //     title: `${APP_TITLE} | Settings`,
    //     path: 'settings',
    //     loadChildren: () => import('./components/pages/settings/routes').then(m => m.routes),
    //     canActivate: [OktaAuthGuard],
    // },
    // {
    //     title: `${title} | Settings`,
    //     path: 'settings',
    //     loadComponent: () => import('./components/pages/home/home.component')
    //     //canActivate: [AuthGuard],
    // },
    { path: 'login/callback', component: OktaCallbackComponent },
    {
        path: '',
        redirectTo: '/dashboard-new',
        pathMatch: 'full'
    },
];
